<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
          <ion-buttons slot="start">
          <ion-menu-button></ion-menu-button>
          </ion-buttons>
        <ion-title>
          TURNOS
        </ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content>
      <ion-refresher slot="fixed" @ionRefresh="recargarTurnos($event);" >
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>

      <ion-fab v-if="tipoUsuario == 1" vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button @click="muestraModalNuevoTurno();" color="secondary">
          <ion-icon name="add"></ion-icon>
        </ion-fab-button>
      </ion-fab>

      <ion-grid v-if="cargando" class="ion-text-center ion-margin-top ion-padding-top">
        <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
          <ion-col size="12">
            <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
          </ion-col>
          <ion-col size="12">
            <ion-label color="dark">CARGANDO . . .</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>

        <ion-card v-for="turno in turnos" :key="'trn-'+turno.trn_id">
          <ion-card-header>
            <ion-card-subtitle>
              <div class="row">
                <div class="col pt-2"><strong>{{turno.trn_nombre}}</strong></div>
                <div v-if="tipoUsuario == 1" class="col text-right">
                  <ion-button @click="muestraModalGestionTurno(turno.trn_id);" color="primary" size="small" shape="round">GESTIONAR <fa :icon="['fad', 'edit']" class="fa-fw ml-2"></fa></ion-button>
                </div>
              </div> 
              <div class="row">
                <div class="col pt-2">DE {{dias[turno.trn_dia_inicio-1]}} A {{dias[turno.trn_dia_fin-1]}}</div>
              </div> 
            </ion-card-subtitle>
            <ion-card-title v-if="turno.usuario">{{turno.usuario.usr_nombres+' '+turno.usuario.usr_apellido_p+' '+turno.usuario.usr_apellido_m}}</ion-card-title>
            <ion-card-title v-else>SIN TURNO ASIGNADO</ion-card-title>
          </ion-card-header>

          <ion-card-content>
            <div class="row" v-if="turno.usuario">
              <div class="col-lg-3 col-sm-12">Fono: +56 {{turno.usuario.usr_telefono}}</div>
              <div class="col">Correo: {{turno.usuario.usr_correo}}</div>
            </div>
            <div class="row">
              <div class="col mt-3 text-justify">{{turno.trn_mensaje}}</div>
            </div>
          </ion-card-content>
        </ion-card>
      <div>
      </div>

    </ion-content>
    
  </ion-page>
</template>

<script>
import { Preferences  } from '@capacitor/preferences';
import { addIcons     } from 'ionicons';
import { add          } from 'ionicons/icons';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonMenuButton, IonButtons, IonLabel, IonRefresher, IonRefresherContent, 
        IonSpinner, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonButton, IonIcon, IonFab, IonFabButton, 
        toastController, loadingController, modalController } from '@ionic/vue';
import { defineComponent }  from 'vue';
import { cerrarSesion    }  from '@/plugins/funciones.ts';
import axios                from 'axios';
import rutaBase             from '@/plugins/variables';
import mNuevoTurno          from '../../components/ModalNuevoTurno.vue';
import mGestionTurno        from '../../components/ModalGestionTurno.vue';

export default defineComponent({
  name: 'Turnos',
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonMenuButton, IonButtons, IonLabel, IonRefresher, IonRefresherContent, 
    IonSpinner, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonButton, IonIcon, IonFab, IonFabButton
  },
  data() {
    return { 
      cargando              : false,
      modalCargando         : null,
      turnos                : [],
      modalNuevoTurno       : null,
      modalGestionTurno     : null,
      dias                  : ['LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO', 'DOMINGO'],
      tipoUsuario           : 0
    }
  },
  created() {
    addIcons({
      'add' : add
    });
  },
  mounted(){
    this.listarTurnos();
    this.obtenerTipoUsusario();
  },
  methods:{
    async muestraModalCargando(){
      this.modalCargando = await loadingController
        .create({
          cssClass  : 'text-secondary',
          message   : 'CARGANDO...',
          animated  : false,
          mode      : 'md'
        });
      await this.modalCargando.present();
    },

    async obtenerTipoUsusario(){
      const tipo = await Preferences.get({ key: 'tipo_usuario' });
      this.tipoUsuario = tipo.value;
    },

    async listarTurnos(){
      await this.muestraModalCargando();
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/turnos/listarTurnos', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.turnos = resp.data.turnos;
        this.modalCargando.dismiss();
      }).catch(() =>{
        this.modalCargando.dismiss();
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async recargarTurnos(evento=false){
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/turnos/listarTurnos', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.turnos = resp.data.turnos;
        if(evento){ evento.target.complete(); }
      }).catch(() =>{
        if(evento){ evento.target.complete(); }
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async muestraModalGestionTurno(idTurno){
      this.modalGestionTurno = await modalController
        .create({
          component: mGestionTurno,
          componentProps: {idTurno: idTurno},
          backdropDismiss: false
        });
      this.modalGestionTurno.present();
      const modalResponse = await this.modalGestionTurno.onDidDismiss();
      modalResponse.data && this.modalCierreGestion()
    },
    
    async muestraModalNuevoTurno(){
      this.modalNuevoTurno = await modalController
        .create({
          component: mNuevoTurno,
          componentProps: {},
          backdropDismiss: false
        });
      this.modalNuevoTurno.present();
      const modalResponse = await this.modalNuevoTurno.onDidDismiss();
      modalResponse.data && this.modalCierreNuevo({...modalResponse.data})
    },

    modalCierreGestion() {
      this.listarTurnos();
    },

    modalCierreNuevo(_value) {
      const datos = _value;
      if(datos.recargar){
        this.listarTurnos();
      }
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
    
  }
});
</script>
